import { toast } from 'react-toastify';

import { type NotificationProvider } from '../notification-provider';

export const toastifyProvider: NotificationProvider = {
  success: (message) =>
    toast.success(message, {
      toastId: message,
      autoClose: 5000,
      hideProgressBar: true
    }),
  warning: (message) =>
    toast.warning(message, {
      toastId: message,
      autoClose: 5000,
      hideProgressBar: true
    }),
  error: (message) =>
    toast.error(message, {
      toastId: message,
      autoClose: 5000,
      hideProgressBar: true
    }),
  info: (message) =>
    toast.info(message, {
      toastId: message,
      autoClose: 5000,
      hideProgressBar: true
    })
};
